<div style="padding: 16px;">
  <h2 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="padding-bottom: 10px;">
    {{title}}
    @if (isLoaded) {
      <div fxLayout="column" fxLayoutAlign="center end">
        @if (showVertMenu) {
          <note-and-attachment [additionalCommands]="additionalCommands" [disableAttachments]="disableAttachments" [disableNotes]="disableNotes" [entity]="noteAttachmentEntity" [hideSubject]="hideNoteSubject" (addAttachment)="onBeforeDocumentAttach()">
          </note-and-attachment>
        }
      </div>
    }
  </h2>

  <mat-dialog-content>
    @if (!isLoaded) {
      <div fxLayout="row" fxLayoutAlign="center center">
        <busy-indicator></busy-indicator>
      </div>
    }

    <fieldset class="fsNoFormat" [disabled]="viewOnly">
      <form #form="ngForm">
        <metadata-panel ngModelGroup="pnl_editDialog" [metadata]="metadata" [model]="entity">
      </metadata-panel>
    </form>
  </fieldset>
</mat-dialog-content>

<mat-dialog-actions fxLayoutAlign="end">
  <button mat-button (click)=" cancel()" telemetry="Submission-TableCancel">
    Cancel
  </button>

  @if (canDelete) {
    <button mat-button (click)="closeAndDelete()" telemetry="Submission-TableDelete">
      Delete
    </button>
  }

  @if (canSaveAndNew) {
    <button mat-button [disabled]="!canSave" (click)="saveAndNew()" telemetry="Submission-TableSave&New">
      Save & New
    </button>
  }

  @if (canSaveAndNext) {
    <button mat-button [disabled]="!canSave" (click)="saveAndNext()" telemetry="Submission-TableSave&Next">
      Save & Next
    </button>
  }

  @if (canMoveNext) {
    <button mat-button (click)="saveAndNext()" telemetry="Submission-TableViewNext">
      View Next
    </button>
  }

  <button mat-raised-button color="primary" [disabled]="!canSave" (click)="save()" telemetry="Submission-TableSave">
    Save
  </button>
</mat-dialog-actions>
</div>
